import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Instrument selector for the Pocket views — Forex pair / Futures contract.
// Sits ABOVE Entry. Generic: the caller passes the current value, the option
// list ([{ value, label, hint }]) and an onSelect handler. Crypto and Stocks
// don't render this (the user enters no instrument there).
const PocketInstrument = ({ value, options = [], onSelect, sub }) => {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.value === value) || options[0];

  return (
    <div className="relative mb-1.5">
      <button
        onClick={() => setOpen((v) => !v)}
        className="group flex items-baseline gap-2 pt-0.5 pb-2 text-left"
      >
        <span className="flex items-baseline gap-1 shrink-0">
          <span className="pk-mono text-[14px] font-medium text-[#eef3f8] group-hover:text-white tracking-wide">{current?.label || '--'}</span>
          <ChevronDown size={11} className="text-[#6b7480] self-center group-hover:text-[#cdd4de] transition-colors" />
        </span>
        {sub && <span className="text-[10px] text-[#5b6573] truncate">{sub}</span>}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-20" onClick={() => setOpen(false)} />
          <div className="pk-scroll absolute left-0 right-0 mt-1 z-30 bg-[#11161f] border border-white/10 rounded-xl shadow-xl p-1 max-h-[260px] overflow-y-auto">
            {options.map((o) => (
              <button
                key={o.value}
                onClick={() => { onSelect && onSelect(o.value); setOpen(false); }}
                className={`w-full flex items-center justify-between text-left px-2.5 py-1.5 rounded-md text-[12.5px] transition-colors ${
                  o.value === current?.value ? 'text-white bg-white/[0.06]' : 'text-[#cdd4de] hover:bg-white/[0.04]'
                }`}
              >
                <span className="font-medium">{o.label}</span>
                {o.hint && <span className="text-[10.5px] text-[#5b6573]">{o.hint}</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PocketInstrument;
